<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { getfinancialrecords, getTradesData, getOrdersData, getTradeFeeData, getProfitData, getChargeData} from '@/api/user'

/**
 * Starter component
 */
export default {
  page: {
    title: "数据管理",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "数据管理",
      items: [
        {
          text: "Utility",
          href: "/"
        },
        {
          text: "Starter Page",
          active: true
        }
      ],
      userName: '',
      userId: '',
      user: [],
      exchangeName: '',

      order_totalRows: 1,
      order_currentPage: 1,
      order_perPage: 10,
      order_pageOptions: [10, 25, 50, 100],
      order_filter: "",
      order_filterOn: [],
      order_sortBy: "-time",
      order_sortDesc: false,
      order_count: 0,

      trade_totalRows: 1,
      trade_currentPage: 1,
      trade_perPage: 10,
      trade_pageOptions: [10, 25, 50, 100],
      trade_filter: "",
      trade_filterOn: [],
      trade_sortBy: "-time",
      trade_sortDesc: false,
      trade_count: 0,
      trade_model: 1,

      transfer_totalRows: 1,
      transfer_currentPage: 1,
      transfer_perPage: 10,
      transfer_pageOptions: [10, 25, 50, 100],
      transfer_filter: "",
      transfer_filterOn: [],
      transfer_sortBy: "-time",
      transfer_sortDesc: false,
      transfer_count: 0,


      charge_list: [],
      profit_totalRows: 1,
      profit_currentPage: 1,
      profit_perPage: 10,
      profit_pageOptions: [10, 25, 50, 100],
      profit_filter: "",
      profit_filterOn: [],
      profit_sortBy: "-time",
      profit_sortDesc: false,
      profit_count: 0,
      profitData: [],
      profitfields: [
        {
          key: "账户名",
          sortable: true
        },
        {
          key: "日期",
          sortable: true
        },
        {
          key: "收益",
          sortable: true
        },
        {
          key: "币种",
          sortable: true
        },
      ],

      chargefields: [
        {
          key: "账户名",
          sortable: true
        },
        {
          key: "日期",
          sortable: true
        },
        {
          key: "操作类型",
          sortable: true
        },
        {
          key: "金额",
          sortable: true
        },
        {
          key: "币种",
          sortable: true
        },
      ],


      financialrecords: [],
      financialrecordsfields: [
        {
            key: "id",
            sortable: true,
        },
        {
            key: "createDatetime",
            sortable: true,
        },
        {
            key: "contractCode",
            sortable: true,
        },
        {
            key: "recordType",
            sortable: true,
        },
        {
            key: "amount",
            sortable: true,
        },
        {
            key: "exchangeName",
            sortable: true,
        },
      ],
      transferfields: [
        {
          key: "date",
          sortable: true
        },
        {
          key: "alias",
          sortable: true
        },
        {
          key: "exchange",
          sortable: true
        },
        {
          key: "fee",
          sortable: true
        },
        {
          key: "volume",
          sortable: true
        },
      ],
      transferData: [],
      orderfields: [
        {
          key: "time",
          sortable: true
        },
        {
          key: "alias",
          sortable: true
        },
        {
          key: "exchange",
          sortable: true
        },
        {
          key: "symbol",
          sortable: true
        },
        {
          key: "side",
          sortable: true
        },
        {
          key: "price",
          sortable: true
        },
        {
          key: "size",
          sortable: true
        },
        {
          key: "status",
          sortable: true
        },
        {
          key: "is_maker",
          sortable: true
        },
      ],
      orderData: [],
      tradefields: [
        {
          key: "time",
          sortable: true
        },
        {
          key: "alias",
          sortable: true
        },
        {
          key: "exchange",
          sortable: true
        },
        {
          key: "symbol",
          sortable: true
        },
        {
          key: "side",
          sortable: true
        },
        {
          key: "price",
          sortable: true
        },
        {
          key: "size",
          sortable: true
        },
        {
          key: "fee",
          sortable: true
        },
        {
          key: "fee_coin",
          sortable: true
        },
      ],
      tradedata: [],
      account: '',
      alias: ''
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    order_rows() {
        return this.orderData.length;
    },
    transfer_rows() {
        return this.orderData.length;
    },
  },
  mounted() {
    this.get_charge_data()
  },
  methods: {
    orderOnFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.order_totalRows = filteredItems.length;
      this.order_currentPage = 1;
    },
    tradeOnFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.trade_totalRows = filteredItems.length;
      this.trade_currentPage = 1;
    },
    transferOnFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.transfer_totalRows = filteredItems.length;
      this.transfer_currentPage = 1;
    },
    profitOnFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.profit_totalRows = filteredItems.length;
      this.profit_currentPage = 1;
    },
    trade_data() {
      let promise = getTradesData(this.trade_filter, this.trade_perPage, this.trade_currentPage-1); return promise.then(res => {
        this.trade_count = res["count"]
        // this.trade_currentPage = res["offset"] + 1
        console.log(this.trade_currentPage)
        return res["data"]
      }).catch(error => {
        console.log(error)
      })
    },
    order_data() {
      let promise = getOrdersData(this.order_filter, this.order_perPage, this.order_currentPage-1); return promise.then(res => {
        this.order_count = res["count"]
        // this.trade_currentPage = res["offset"] + 1
        console.log(this.order_currentPage)
        return res["data"]
      }).catch(error => {
        console.log(error)
      })
    },
    transfer_data() {
      let promise = getTradeFeeData(this.transfer_filter, this.transfer_perPage, this.transfer_currentPage-1); return promise.then(res => {
        this.transfer_count = res["count"]
        // this.trade_currentPage = res["offset"] + 1
        console.log(this.transfer_currentPage)
        return res["data"]
      }).catch(error => {
        console.log(error)
      })
    },
    profit_data() {
      let promise = getProfitData(this.profit_filter, this.profit_perPage, this.profit_currentPage-1); return promise.then(res => {
        this.profit_count = res["count"]
        // this.trade_currentPage = res["offset"] + 1
        console.log(this.profit_currentPage)
        return res["data"]
      }).catch(error => {
        console.log(error)
      })
    },
    get_charge_data() {
      let promise = getChargeData(); return promise.then(res => {
        this.charge_list = res
      }).catch(error => {
        console.log(error)
      })
    },
  }
};
</script>
<template>
  <Layout>
    <PageHeader
      :title="title"
    />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              交易记录
            </h4>
            <b-tabs
              content-class="mt-3"
              nav-class="nav-tabs-custom"
            >
              <b-tab
                title="All"
                active
              >
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_length"
                      class="dataTables_length"
                    >
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="trade_perPage"
                          size="sm"
                          :options="trade_pageOptions"
                        />&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="trade_filter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ml-2"
                        />
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive table-hover mb-0">
                  <b-table ref="trade_table"
                    :items="trade_data"
                    :fields="tradefields"
                    responsive="sm"
                    :per-page="trade_perPage"
                    :current-page="trade_currentPage"
                    :sort-by.sync="trade_sortBy"
                    :sort-desc.sync="trade_sortDesc"
                    :filter="trade_filter"
                    :filter-included-fields="trade_filterOn"
                  />
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="trade_currentPage"
                          :total-rows="trade_count"
                          :per-page="trade_perPage"
                          first-number
                          last-number
                        />
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>
              <!-- <b-tab title="Buy" disabled> </b-tab>
                        <b-tab title="Sell" disabled> </b-tab> -->
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              订单记录
            </h4>
            <b-tabs
              content-class="mt-3"
              nav-class="nav-tabs-custom"
            >
              <b-tab
                title="All"
                active
              >
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_length"
                      class="dataTables_length"
                    >
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="order_perPage"
                          size="sm"
                          :options="order_pageOptions"
                        />&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="order_filter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ml-2"
                        />
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive table-hover mb-0">
                  <b-table 
                    :items="order_data"
                    :fields="orderfields"
                    responsive="sm"
                    :per-page="order_perPage"
                    :current-page="order_currentPage"
                    :sort-by.sync="order_sortBy"
                    :sort-desc.sync="order_sortDesc"
                    :filter="order_filter"
                    :filter-included-fields="order_filterOn"
                  />
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="order_currentPage"
                          :total-rows="order_count"
                          :per-page="order_perPage"
                          first-number
                          last-number
                        />
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>
              <!-- <b-tab title="Buy" disabled> </b-tab>
                        <b-tab title="Sell" disabled> </b-tab> -->
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              交易费用
            </h4>
            <b-tabs
              content-class="mt-3"
              nav-class="nav-tabs-custom"
            >
              <b-tab
                title="All"
                active
              >
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_length"
                      class="dataTables_length"
                    >
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="transfer_perPage"
                          size="sm"
                          :options="transfer_pageOptions"
                        />&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="transfer_filter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ml-2"
                        />
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive table-hover mb-0">
                  <b-table
                    :items="transfer_data"
                    :fields="transferfields"
                    responsive="sm"
                    :per-page="transfer_perPage"
                    :current-page="transfer_currentPage"
                    :sort-by.sync="transfer_sortBy"
                    :sort-desc.sync="transfer_sortDesc"
                    :filter="transfer_filter"
                    :filter-included-fields="transfer_filterOn"
                  />
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="transfer_currentPage"
                          :total-rows="transfer_count"
                          :per-page="transfer_perPage"
                          first-number
                          last-number
                        />
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>
              <!-- <b-tab title="Buy" disabled> </b-tab>
                        <b-tab title="Sell" disabled> </b-tab> -->
            </b-tabs>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              收益明细
            </h4>
            <b-tabs
              content-class="mt-3"
              nav-class="nav-tabs-custom"
            >
              <b-tab
                title="All"
                active
              >
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_length"
                      class="dataTables_length"
                    >
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="profit_perPage"
                          size="sm"
                          :options="profit_pageOptions"
                        />&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label  class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="profit_filter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ml-2"
                        />
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive table-hover mb-0">
                  <b-table
                    :items="profit_data"
                    :fields="profitfields"
                    responsive="sm"
                    :per-page="profit_perPage"
                    :current-page="profit_currentPage"
                    :sort-by.sync="profit_sortBy"
                    :sort-desc.sync="profit_sortDesc"
                    :filter="profit_filter"
                    :filter-included-fields="profit_filterOn"
                  />
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="profit_currentPage"
                          :total-rows="profit_count"
                          :per-page="profit_perPage"
                          first-number
                          last-number
                        />
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>
              <!-- <b-tab title="Buy" disabled> </b-tab>
                        <b-tab title="Sell" disabled> </b-tab> -->
            </b-tabs>
          </div>
        </div>
      </div>
    </div>


    <div  class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              充提记录
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="charge_list"
                  :fields="chargefields"
                />
              </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>